/* eslint-disable no-trailing-spaces */
/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable react/sort-comp */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable camelcase */
/* eslint-disable max-len */
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import IMG_REGULAR_CLIENTS from 'assets/images/ActiveClientsHeaderBarImage.svg';
import ICO_CHARGE from 'assets/images/dialogs/ChargeSuccessful.svg';
import IMG_ALL_CLIENTS from 'assets/images/marketing-all-list.svg';
import IMG_BIRTHDAY from 'assets/images/marketing-birthday-list.svg';
import IMG_LOST_CLIENTS from 'assets/images/marketing-lost-list.svg';
import IMG_NEW_CLIENTS from 'assets/images/marketing-new-list.svg';
import IMG_REVIEW from 'assets/images/marketing-review-list.svg';
import IMG_UPCOMING_CLIENTS from 'assets/images/marketing-upcoming-list.svg';
import Button from 'components/form/Button.component';
import DropdownFoldout from 'components/generic/DropdownFoldout.component';
import Icon from 'components/generic/Icon.component';
import Tooltip from 'components/generic/Tooltip.component';
import StripeAccountVerifierModal from 'components/modal/StripeAccountVerifierModal.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { withIsFromMobileApp } from 'hooks/useIsFromMobileApp.hook';
import { withGilt } from 'providers/GILT.provider';
import { withSalonRestriction } from 'providers/SalonBasicInfo.provider';
import { withTheme } from 'providers/Theme.provider';
import { selectCurrentSalonBetaAnnualSalon, selectCurrentSalonBilling } from 'selectors/currentSalon.selectors';
import { exportCSV } from 'utils/converters/csv.util';

import SimpleDialog from 'scheduler/components/SimpleDialog';
import NoBillingModal from 'settings/online-booking/modals/NoBillingModal';
import Checkbox from 'settings/page-elements/dropdown/Checkbox';

import CN from './ClientHeader.module.scss';

class ClientHeader extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.myRef = React.createRef();

    this.state = {
      modalDeleteClients: false,
      modalOptOut: false,
      deleteProcess: false,
      dropdown: false,
      clients_with_notes: [],
      getAllClientCalled: false,
      deleteAllPopup: false,
      modalClientNoPhone: false,
      isBillingRendered: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    this.props.resetBulkDeleteResponse();
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.clients_with_notes && nextProps.clients_with_notes.length > 0) {
      this.setState({
        modalDeleteClients: true,
        deleteProcess: false,
        dropdown: false,
        clients_with_notes: nextProps.clients_with_notes,
      });
    }
    if (nextProps.bulkDeleteSuccess && !this.state.getAllClientCalled) {
      this.props.getClientsList(this.props.salonId);
      this.setState({ getAllClientCalled: true });
    }
  }

  handleClickOutside = (e) => {
    if (this.myRef && this.myRef.current && !this.myRef.current.contains(e.target)) {
      this.setState({ dropdown: false });
    }
  };

  onImageUpload = () => {
    switch (this.props.bucketType) {
      case 'withphone':
        return IMG_ALL_CLIENTS;
      case 'list':
        return IMG_ALL_CLIENTS;
      case 'lost':
        return IMG_LOST_CLIENTS;
      case 'active':
        return IMG_REGULAR_CLIENTS;
      case 'recent':
        return IMG_REVIEW;
      case 'upcoming':
        return IMG_UPCOMING_CLIENTS;
      case 'first':
        return IMG_NEW_CLIENTS;
      case 'birthday':
        return IMG_BIRTHDAY;
      case 'cancelations':
        return IMG_LOST_CLIENTS;
      default:
        return IMG_ALL_CLIENTS;
    }
  };

  generateTitle = () => {
    const { t } = this.props;
    switch (this.props.bucketType) {
      case 'withphone':
        return t('allClients.title.withPhone');
      case 'list':
        return t('allClients.title.list');
      case 'lost':
        return t('allClients.title.lost');
      case 'active':
        return t('allClients.title.active');
      case 'recent':
        return t('allClients.title.recent');
      case 'upcoming':
        return t('allClients.title.upcoming');
      case 'first':
        return t('allClients.title.first');
      case 'birthday':
        return t('allClients.title.birthday');
      case 'cancelations':
        return t('allClients.title.cancellations');
      default:
        return t('allClients.title.all');
    }
  };

  generateTooltip = () => {
    const { t } = this.props;
    switch (this.props.bucketType) {
      case 'withphone':
        return t('allClients.tooltip.withPhone');
      case 'list':
        return t('allClients.tooltip.list');
      case 'lost':
        return t('allClients.tooltip.lost');
      case 'active':
        return t('allClients.tooltip.active');
      case 'recent':
        return t('allClients.tooltip.recent');
      case 'upcoming':
        return t('allClients.tooltip.upcoming');
      case 'first':
        return t('allClients.tooltip.first');
      case 'birthday':
        return t('allClients.tooltip.birthday');
      case 'cancelations':
        return t('allClients.tooltip.cancellations');
      case 'invalid_patch_test':
        return t('allClients.tooltip.invalid_patch_test');
      default:
        return t('allClients.tooltip.all');
    }
  };

  showModalDeleteClients = () => {
    this.setState({ deleteAllPopup: true, dropdown: false });
  };

  doDeleteClients = () => {
    const IDs = this.props.selectedClients.map((c) => c.id);
    this.props.bulkDelete(IDs, true);
    this.setState({ deleteProcess: true });
  };

  onDeleteClientsRequest = () => {
    this.setState({ modalDeleteClients: false });
    const IDs = this.props.clients_with_notes.map((c) => c.id);
    // don't check notes this time, just delete
    this.props.bulkDelete(IDs, false);
    this.setState({ deleteProcess: true, getAllClientCalled: false });
  };

  onRequestOkClick = () => {
    this.props.resetBulkDeleteResponse();
    this.props.getAllClientsList(this.props.salonId);
    this.props.getClientsCalculatedList(this.props.salonId, this.props.bucketType);
    this.setState({ deleteProcess: false, deleteAllPopup: false });
  };

  showModalOptOut = () => {
    this.setState({ modalOptOut: true, dropdown: false });
  };

  onOptOutRequest = () => {
    const IDs = this.props.selectedClients.map((c) => c.id);
    this.props.bulkOptout(IDs);
    this.setState({
      modalOptOut: false,
    });
  };

  showDropdown = () => {
    this.setState({ dropdown: true });
  };

  changeClientsWithNotes = (clientId) => {
    const clientWithNotes = Array(this.state.clients_with_notes)[0];
    window.clientWithNotes = clientWithNotes;
    const ind = clientWithNotes.findIndex((e) => e.id === clientId);
    if (ind >= 0) {
      const removed = clientWithNotes.splice(ind, 1);
      this.props.markClientSelect(removed[0].id, false);
    } else {
      const ind2 = this.props.clients_with_notes.findIndex((e) => e.id === clientId);
      clientWithNotes.push(this.props.clients_with_notes[ind2]);
      this.props.markClientSelect(this.props.clients_with_notes[ind2].id, true);
    }
    this.setState({ clients_with_notes: clientWithNotes });
  };

  isChecked = (p) => {
    const arr = this.state.clients_with_notes.filter((c) => c.id === p.id);
    return arr.length > 0;
  };

  handleClickInside = () => {
    this.setState({ dropdown: false });
  };

  createCsvData = () => {
    const { clientList, t } = this.props;
    const headers = [t('allClients.clientsList.clientName'), t('allClients.clientsList.email')];

    const csvData = clientList
      .filter(({ show, email, requested_opt_out }) => show && email && !requested_opt_out)
      .sort((a, b) => (a.user_name < b.user_name ? -1 : 1))
      .map(({ user_name, email }) => ({ [headers[0]]: user_name, [headers[1]]: email }));

    exportCSV({ data: csvData, fileName: t('allClients.clientsWithEmailAddresses') });
  };

  hideNoBilling = () => void this.setState({ isBillingRendered: false });
  showNoBilling = () => void this.setState({ isBillingRendered: true });

  myRef = React.createRef();

  render() {
    const { modalDeleteClients, modalOptOut, isBillingRendered } = this.state;
    const { upcoming_clients, children, hasBetaAnnualSalon, hasBilling } = this.props;
    const { isRestrictedToCriticalServices, isRestrictionCheckEnabled, enableRestrictionCheck, disableRestrictionCheck, isSalonInGB, t, isDarkMode } = this.props;

    const popup = 'smsComposeModalOpen';
    const uniqUpcomingClients = [...new Set(upcoming_clients)];

    const onRequestClose = () => {
      this.setState({
        modalDeleteClients: false,
        modalOptOut: false,
        deleteAllPopup: false,
        modalClientNoPhone: false,
      });
      this.props.resetBulkDeleteResponse();
    };

    const onRequestCloseNote = () => {
      onRequestClose();
      this.props.getAllClientsList(this.props.salonId);
    };

    const handleCreateTextBlast = () => {
      if (isRestrictedToCriticalServices) return void enableRestrictionCheck();

      if (this.props.clientsSelected === 0) return void this.setState({ modalClientNoPhone: true });

      if (hasBetaAnnualSalon || (!hasBetaAnnualSalon && hasBilling)) {
        this.props.showPopup(popup);
        this.props.trackEvent('create_sms');
        return;
      }

      this.showNoBilling();
    };

    return (
      <>
        <div className="client-header">
          {children}
          <div className={CN.clientHeaderContainer}>
            <img className={CN.headerImage} src={this.onImageUpload()} alt="" />
            <div className={CN.scrollContainer}>
              <div className="client-info-container">
                <div className="all-clients-main">
                  <div className="all-clients-pr">
                    <span className="title-general top">{this.generateTitle()}</span>
                    <div className="all-clients-sec">
                      <div className="title-general bottom">
                        <span className="title-label">{this.props.allClients}</span>

                        <div className={CN.smsTooltipContainer}>
                          <Tooltip variant="right" width="max" content={this.generateTooltip()}>
                            <Icon variant="info" width="md" />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="all-clients-se">
                    <span className="title-general top">{t('allClients.clientsSelected')}</span>
                    <div className="all-clients-sec">
                      <div className="title-general bottom">
                        <span className="title-label">{this.props.clientsSelected}</span>
                      </div>
                    </div>
                  </div>
                  <div className="all-clients-tr">
                    <span className="title-general top">{t('allClients.revenueOpportunity')}</span>
                    <div className="all-clients-sec">
                      <div className="title-general bottom">
                        <span className="title-label">
                          <CurrencySign />
                          {this.props.revenueSum}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="all-clients-sms">
                    <span className="title-general top">
                      <div>{t('allClients.textMessagesAvailable')}</div>
                    </span>
                    <div className="all-clients-sec">
                      <div className="title-general bottom">
                        <span className="title-label">{this.props.sms_credits_available}</span>
                        <div className={CN.smsTooltipContainer}>
                          <Tooltip variant="left" width="md" content={t('allClients.smsTooltip')}>
                            <Icon variant="info" width="md" />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={CN.headerButtons}>
              <div className={CN.rowButtonsContainer}>
                <div className={CN.menageButtonContainer}>
                  <Button tag="ClientHeader__menage--clients" variant="emphasis" xSpace onClick={this.showDropdown}>
                    {t('allClients.manageClients')}
                  </Button>
                  {this.state.dropdown && (
                    <DropdownFoldout tag="ManageAppointmentButton__items" width="lg" position="bottom">
                      <DropdownFoldout.Body>
                        <div
                          data-bem="ManageAppointmentButton__items"
                          className={cn({ [CN.dropdownItems]: true, [CN.dark]: isDarkMode })}
                          ref={this.myRef}
                          onClick={this.handleClickInside}
                          role="button"
                          tabIndex={0}
                        >
                          <div className={CN.dropdownItem} onClick={this.showModalDeleteClients} role="button" tabIndex={0}>
                            {t('allClients.deleteSelectedClients')}
                          </div>
                          <div type="button" className={CN.dropdownItem} onClick={this.showModalOptOut} role="button" tabIndex={0}>
                            {t('allClients.optOutSelectedClients')}
                          </div>
                          <NavLink to={`/salon/${this.props.salonId}/communications/mergeclients`} className={CN.dropdownItem}>
                            {t('allClients.findMergeDuplicateClients')}
                          </NavLink>
                          <Button variant="dropdownItem" onClick={this.createCsvData}>
                            {t('allClients.exportClientEmailAddresses')}
                          </Button>
                        </div>
                      </DropdownFoldout.Body>
                    </DropdownFoldout>
                  )}
                </div>

                {isSalonInGB && !this.props.isFromMobile && (
                  <Button
                    tag="ClientHeader__get--texts"
                    variant="tertiary"
                    xSpace
                    onClick={() => {
                      this.props.showPurchasePopup(true);
                    }}
                  >
                    {t('allClients.getMoreTexts')}
                  </Button>
                )}
              </div>
              <div className={CN.rowButtonsContainer}>
                <Button tag="ClientHeader__text--blast" variant="primary" width="fluid" xSpace disabled={this.props.isFetching} onClick={handleCreateTextBlast}>
                  {t('allClients.createTextBlast')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        {this.state.modalClientNoPhone && (
          <div className="popup-2-button animated zoomIn">
            <div className="flex-center">
              <div className="modal-content">
                <div className="sms-title">
                  <div>{t('allClients.smsError')}</div>
                </div>
                <br />
              </div>
            </div>

            <div className="cfix">
              <div className="marketing-button-container">
                <button className="sms-btn-white" onClick={onRequestClose}>
                  {t('common.buttons.back')}
                </button>
              </div>
            </div>
          </div>
        )}
        {this.state.deleteAllPopup && (
          <SimpleDialog
            title=" "
            leftButtonText={t('common.buttons.cancel')}
            rightButtonText={t('allClients.confirmDelete')}
            onLeft={onRequestClose}
            onRight={this.doDeleteClients}
            displayHeader="header-non"
            uniqueClass="delete-clients-with-notes-modal"
            isOpen={this.state.deleteAllPopup}
          >
            <div className="dialog-inner-title">{t('allClients.deleteClientsTitle')}</div>
            <div className="dialog-text">
              <p>{t('allClients.deleteClientsDescription', { count: this.props.selectedClients.length })}</p>
            </div>
          </SimpleDialog>
        )}
        {modalDeleteClients && (
          <SimpleDialog
            title=" "
            leftButtonText={t('allClients.keepAllClientsWithNotes')}
            rightButtonText={t('allClients.deleteSelectedClients')}
            onLeft={onRequestCloseNote}
            onRight={this.onDeleteClientsRequest}
            displayHeader="header-non"
            uniqueClass="delete-clients-with-notes-modal"
            isOpen={this.state.modalDeleteClients}
          >
            {this.props.selectedClients.filter((c) => c.notes !== '').length === 0 && <div className="dialog-inner-title">{t('allClients.deleteClientsTitle')}</div>}
            {this.props.selectedClients.filter((c) => c.notes !== '').length > 0 && (
              <>
                <div className="dialog-inner-title">{t('allClients.notesWarning')}</div>
                <p>{t('allClients.notesWarningDescription', { count: this.props.deleted_count })}</p>
              </>
            )}
            <div className="dialog-text">
              <p>{t('allClients.deleteClientsDescription', { count: this.props.clients_with_notes.length })}</p>
              {this.props.clients_with_notes.map((p) => (
                <div className="client-row">
                  <table className="clients-with-notes">
                    <tr>
                      <td style={{ width: '50px' }}>
                        <label htmlFor={p.id}>
                          <Checkbox isChecked={this.isChecked(p)} id={p.id} onCheckboxClick={() => this.changeClientsWithNotes(p.id)} />
                        </label>
                      </td>
                      <td className="for-name">
                        <strong>{p.name}</strong>
                      </td>
                      <td>
                        <i>{p.notes}</i>
                      </td>
                    </tr>
                  </table>
                </div>
              ))}
            </div>
          </SimpleDialog>
        )}
        {this.state.deleteProcess && this.props.bulkDeleteSuccess && (
          <SimpleDialog
            title=" "
            leftButtonText=" "
            rightButtonText={t('allClients.okThanks')}
            onRight={this.onRequestOkClick}
            displayHeader="header-non"
            isOpen={this.props.upcoming_count > 0 || this.props.deleted_count > 0}
          >
            <div className="dialog-inner-title" />
            <img src={ICO_CHARGE} alt="Request sent!" className="dialog-image" />
            <div className="dialog-text">
              <div className="dialog-inner-title text-center">{t('allClients.clientsHaveBeenDeleted', { count: this.props.deleted_count })}</div>
              {this.props.upcoming_count >= 1 && (
                <div className="clients-with-appointment">
                  <div>{t('allClients.clientsCouldNotBeDeleted', { count: this.props.upcoming_count })}:</div>
                  <ul>
                    {uniqUpcomingClients.map((c) => (
                      <li>{c}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </SimpleDialog>
        )}
        {modalOptOut && (
          <SimpleDialog
            title=" "
            leftButtonText={t('common.buttons.cancel')}
            rightButtonText={t('allClients.confirmOptOut')}
            onLeft={onRequestClose}
            onRight={this.onOptOutRequest}
            displayHeader="header-non"
            uniqueClass="wide-btn"
            isOpen={this.state.modalOptOut}
          >
            <div className="dialog-inner-title">{t('allClients.optOutClientsTitle')}</div>
            <div className="dialog-text">
              <p>{t('allClients.optOutClientsDescription')}</p>
              <p>{t('allClients.optOutClientsDescription2')}</p>
            </div>
          </SimpleDialog>
        )}
        {this.props.bulkOptoutSuccess && (
          <SimpleDialog
            title=" "
            leftButtonText=""
            rightButtonText={t('common.buttons.ok')}
            onLeft={onRequestClose}
            onRight={onRequestClose}
            displayHeader="header-non"
            uniqueClass="wide-btn"
            isOpen={this.props.bulkOptoutSuccess}
          >
            <div className="dialog-inner-title">{t('allClients.clientsOptedOut')}</div>
          </SimpleDialog>
        )}
        {isBillingRendered && <NoBillingModal isOpen onClose={this.hideNoBilling} />}

        <StripeAccountVerifierModal tag="ClientHeader__restriction-modal" enabled={isRestrictionCheckEnabled} onCancel={disableRestrictionCheck} onClose={disableRestrictionCheck} />
      </>
    );
  }
}

const ClientHeaderHoc = connect((state) => ({
  hasBetaAnnualSalon: selectCurrentSalonBetaAnnualSalon(state),
  hasBilling: selectCurrentSalonBilling(state),
}))(withIsFromMobileApp(withSalonRestriction(withGilt(withTranslation()(withTheme()(ClientHeader))))));

export default ClientHeaderHoc;
